/**
 * 組織（division/team）で OptionsSelectList をフィルタする共通ユーティリティ
 */
import { OptionsSelectList } from '../state/master';

/**
 * 指定の division / team に合致するかを判定する述語を生成
 */
export const makeOrgOptionFilter = (division?: number, team?: number) => (line: OptionsSelectList): boolean => {
  const depId = Number(division ?? 0);
  const teamId = Number(team ?? 0);

  const lineDep = Number((line as any)?.department_id ?? 0);
  const lineTeam = Number((line as any)?.team_id ?? 0);

  // department は「選択中課」または「共通(0)」を許容
  const divOK = !Number.isFinite(depId) || depId <= 0
    ? true
    : (lineDep === depId || lineDep === 0 || (line as any)?.department_id == null);

  // team は厳密一致のみ（共通(0)は filterOptionsByOrg 側でフォールバック判定）
  const teamOK = !Number.isFinite(teamId) || teamId <= 0
    ? true
    : (lineTeam === teamId || (line as any)?.team_id == null);

  return divOK && teamOK;
};

/**
 * Options 配列を division / team でフィルタ
 */
export const filterOptionsByOrg = (
  options: OptionsSelectList[] | null | undefined,
  division?: number,
  team?: number
): OptionsSelectList[] => {
  if (!Array.isArray(options)) return [];

  const depId = Number(division ?? 0);
  const teamId = Number(team ?? 0);
  const hasTeam = Number.isFinite(teamId) && teamId > 0;

  // まず department スコープ（選択中課 + 共通）で絞る
  const depScoped = options.filter((line) => {
    const lineDep = Number((line as any)?.department_id ?? 0);
    if (!Number.isFinite(depId) || depId <= 0) return true;
    return lineDep === depId || lineDep === 0 || (line as any)?.department_id == null;
  });

  // team優先: selected team が1件でもあればそれのみ、無ければ common(team_id=0) を採用
  let picked = depScoped;
  if (hasTeam) {
    const teamMatched = depScoped.filter((line) => Number((line as any)?.team_id ?? 0) === teamId);
    if (teamMatched.length > 0) {
      picked = teamMatched;
    } else {
      picked = depScoped.filter((line) => Number((line as any)?.team_id ?? 0) === 0 || (line as any)?.team_id == null);
    }
  }

  // 表示用に value > label 優先で重複排除
  const seen = new Set<string>();
  const deduped: OptionsSelectList[] = [];
  picked.forEach((line) => {
    const value = String((line as any)?.value ?? '').trim();
    const label = String((line as any)?.label ?? '').trim();
    const key = value !== '' ? `v:${value}` : `l:${label}`;
    if (seen.has(key)) return;
    seen.add(key);
    deduped.push(line);
  });

  return deduped;
};
